'use strict'

import { setUnderline } from '../modules/concert-nav';
import { getAllDigitalConcerts } from '../services/digital-inventory';
import { loadComponent } from './utils/load-component';

loadComponent('digital-panel', {
    props: {
        id: {
            type: Number,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                DigitalConcert: null,
                IsPurchased: false,
            },
        }
    },

    beforeMount() {
        getAllDigitalConcerts().then(response => {
            const found = response.find(item => {
                return parseInt(item.id, 10) === parseInt(this.id, 10);
            });

            if (found) {
                found.price = found.price ? `$${found.price.toFixed(2)}` : null;

                this.ViewModel.DigitalConcert = found;

                if (found.video_id) {
                    this.ViewModel.IsPurchased = true;
                }
            }
        }).finally(() => {
            this.ViewModel.Loading = false;

            if (!this.ViewModel.DigitalConcert) {
                document.querySelector('[href="#digital"]').closest('.concert-navigation__item').remove();
                setUnderline();
            }
        });
    },
})
